export default "__VITE_ASSET__BtaDs9u4__"